import { Helmet } from 'react-helmet'
import { useLocation } from 'react-router-dom'

// Interactive tools and account pages are not part of the reference archive.
// Keep in sync with public/robots.txt and the X-Robots-Tag headers in firebase.json.
const NOINDEX_PREFIXES = [
  '/game',
  '/games',
  '/buzzer',
  '/timer',
  '/leaderboard',
  '/organizer',
  '/ratings/admin',
  '/sheets',
  '/login',
  '/register',
  '/forgot',
  '/profile',
  '/reset-password',
  '/confirm',
  '/verify-reference',
  '/success',
]

export default function NoIndexRoutes() {
  const { pathname } = useLocation()
  const hidden = NOINDEX_PREFIXES.some((p) => pathname === p || pathname.startsWith(p + '/'))
  if (!hidden) return null
  return (
    <Helmet>
      <meta name="robots" content="noindex, nofollow" />
    </Helmet>
  )
}
